import * as scmpAccount from "@product/scmp-account-sdk";

import { config } from "shared/data";

export const useAccountSDKSetup = () => {
  const accountUrl = new URL(config.account.scmpAccountHost);
  scmpAccount.init({
    AMP_READER_ID: config.account.ampReaderId,
    APPLICATION: config.account.application,
    AUTH_CALLBACK_URL: config.account.authCallbackUrl,
    DEBUG_LOG: config.account.debugLog,
    DESTINATION: config.account.authDestination,
    GTM_CONTAINER_ID: config.googleTagManager.containerId,
    RECAPTCHA_CONTAINER_ID: config.account.recaptchaContainerId,
    RECAPTCHA_SITE_KEY: config.account.recaptchaSiteKey,
    RECAPTCHA_VERSION: "v3",
    REGISTER_CALLBACK_URL: config.account.registerCallbackUrl,
    SCMP_ACCOUNT_HOST: accountUrl.host,
    SCMP_ACCOUNT_PROTOCOL: accountUrl.protocol.slice(0, -1),
    widget: {
      loginOptions: {
        apple: true,
        email: true,
        facebook: true,
        google: true,
      },
      sendWelcomeEmail: config.account.sendWelcomeEmail,
    },
  });
};
